<template>
  <div class="donut-chart">
    <div class="item">
      <svg width="160" height="160" xmlns="http://www.w3.org/2000/svg">
        <g>
          <circle id="circle-back" class="circle_animation-2" r="60" cy="81" cx="81" stroke-width="9" stroke="#ffffff" fill="none"/>
        </g>
      </svg>
    </div>
    <div :class="[{ animateProgess: animate }, stepClass]" class="item">
      <h2>{{stepNum}}/{{steps}}</h2>
      <svg width="160" height="160" xmlns="http://www.w3.org/2000/svg">
        <g>
          <circle id="circle" class="circle_animation" r="60" cy="81" cx="81" stroke-width="9" stroke="#3ecf8e" fill="none"/>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      steps: {
        default: 6
      },
      stepNum: {
        default: 3
      },
      animate: {
        default: false
      }
    },
    computed: {
      stepClass () {
        return 'css' + this.stepNum + '-' + this.steps
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .donut-chart {
    display: flex;
    text-align: center;
    margin: 0 auto;
    height: 150px;
    overflow: hidden;
    position: relative;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .item {
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }

  .item h2 {
    text-align:center;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    color:white;
    font-size: 30px;
    margin-top: -6px;
    width: 100%;
    height: 100%;
  }

  svg {
    transform: rotate(-90deg);
  }

  .circle_animation {
    stroke-dasharray: 440;
    stroke-dashoffset: 440;
  }

  .animateProgess .circle_animation {
    animation-duration: 1s !important;
  }

  .css0-6 .circle_animation {
    animation: css0-6 0s linear forwards;
  }
  .css1-6 .circle_animation {
    animation: css1-6 0s linear forwards;
  }
  .css2-6 .circle_animation {
    animation: css2-6 0s linear forwards;
  }
  .css3-6 .circle_animation {
    animation: css3-6 0s linear forwards;
  }
  .css4-6 .circle_animation {
    animation: css4-6 0s linear forwards;
  }
  .css5-6 .circle_animation {
    animation: css5-6 0s linear forwards;
  }
  .css6-6 .circle_animation {
    animation: css6-6 0s linear forwards;
  }

  @keyframes css0-6 {
    to {
      stroke-dashoffset: calc(440 - ((440 / 7) * 0));
    }
  }
  @keyframes css1-6 {
    to {
      stroke-dashoffset: calc(440 - ((440 / 7) * 1));
    }
  }
  @keyframes css2-6 {
    from {
      stroke-dashoffset: calc(440 - ((440 / 7) * 1));
    }
    to {
      stroke-dashoffset: calc(440 - ((440 / 7) * 2));
    }
  }
  @keyframes css3-6 {
    from {
      stroke-dashoffset: calc(440 - ((440 / 7) * 2));
    }
    to {
      stroke-dashoffset: calc(440 - ((440 / 7) * 3));
    }
  }
  @keyframes css4-6 {
    from {
      stroke-dashoffset: calc(440 - ((440 / 7) * 3));
    }
    to {
      stroke-dashoffset: calc(440 - ((440 / 7) * 4));
    }
  }
  @keyframes css5-6 {
    from {
      stroke-dashoffset: calc(440 - ((440 / 7) * 4));
    }
    to {
      stroke-dashoffset: calc(440 - ((440 / 7) * 5));
    }
  }
  @keyframes css6-6 {
    from {
      stroke-dashoffset: calc(440 - ((440 / 7) * 5));
    }
    to {
      stroke-dashoffset: calc(440 - ((440 / 7) * 6));
    }
  }

  .css0-7 .circle_animation {
    animation: css0-7 0s linear forwards;
  }
  .css1-7 .circle_animation {
    animation: css1-7 0s linear forwards;
  }
  .css2-7 .circle_animation {
    animation: css2-7 0s linear forwards;
  }
  .css3-7 .circle_animation {
    animation: css3-7 0s linear forwards;
  }
  .css4-7 .circle_animation {
    animation: css4-7 0s linear forwards;
  }
  .css5-7 .circle_animation {
    animation: css5-7 0s linear forwards;
  }
  .css6-7 .circle_animation {
    animation: css6-7 0s linear forwards;
  }
  .css7-7 .circle_animation {
    animation: css7-7 0s linear forwards;
  }

  @keyframes css0-7 {
    to {
      stroke-dashoffset: calc(440 - ((440 / 8) * 0));
    }
  }
  @keyframes css1-7 {
    to {
      stroke-dashoffset: calc(440 - ((440 / 8) * 1));
    }
  }
  @keyframes css2-7 {
    from {
      stroke-dashoffset: calc(440 - ((440 / 8) * 1));
    }
    to {
      stroke-dashoffset: calc(440 - ((440 / 8) * 2));
    }
  }
  @keyframes css3-7 {
    from {
      stroke-dashoffset: calc(440 - ((440 / 8) * 3));
    }
    to {
      stroke-dashoffset: calc(440 - ((440 / 8) * 4));
    }
  }
  @keyframes css4-7 {
    from {
      stroke-dashoffset: calc(440 - ((440 / 8) * 3));
    }
    to {
      stroke-dashoffset: calc(440 - ((440 / 8) * 4));
    }
  }
  @keyframes css5-7 {
    from {
      stroke-dashoffset: calc(440 - ((440 / 8) * 4));
    }
    to {
      stroke-dashoffset: calc(440 - ((440 / 8) * 5));
    }
  }
  @keyframes css6-7 {
    from {
      stroke-dashoffset: calc(440 - ((440 / 8) * 5));
    }
    to {
      stroke-dashoffset: calc(440 - ((440 / 8) * 6));
    }
  }
  @keyframes css7-7 {
    from {
      stroke-dashoffset: calc(440 - ((440 / 8) * 6));
    }
    to {
      stroke-dashoffset: calc(440 - ((440 / 8) * 7));
    }
  }

</style>



// WEBPACK FOOTER //
// StepDoughnut.vue?ec76e294